'use strict';

const Mn = require('backbone.marionette');
const Template = require('data/ui/template/modal/url-copy.hbs');

module.exports = Mn.View.extend({
    template: Template,
    templateContext: function() {
        return {
            name: this.getOption('name'),
            url: this.getOption('url')
        }
    },

    copyURL: function() {
        return new Promise((resolve, reject) => {
            this.$('.url-text').select();
            const res = document.execCommand('copy');
            if(res) {
                resolve(res);
            }else{
                reject();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./data/ui/view/modal/url-copy.js